module.exports = __webpack_public_path__ + "static/media/chevron.af6b394b.svg";